import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { customHistory } from "../../framework/customHistory";
import { DocumentListBlock } from "../document/documentListBlock";
import { IFrontPageDocumentState } from "../../models/store/storeTypes";
import { PanelTitle } from "../framework/panelTitle";
import { FrontPageInfoMessage } from "./frontPageInfoMessage";

//FrontPageDocument
export interface IFrontPageDocumentProps {
    state: IFrontPageDocumentState;
    loadFrontPageDocument: () => void;
    setLastOpenedDocumentId: (id: string) => void;
}

export class FrontPageDocument extends React.Component<IFrontPageDocumentProps, {}> {
    private hasBeenInitialized = false;

    componentDidMount(): void {
        this.props.loadFrontPageDocument();
        this.hasBeenInitialized = true;
    }

    handleDocumentLineClick = (id: string, companyId: string) => {
        this.props.setLastOpenedDocumentId(id);
        customHistory.push("/document/" + id + "/" + companyId);
    };

    render() {
        const props = this.props;
        const documents = props.state?.documents ?? [];
        return (
            <div className="panelContainer">
                <div className="panel documentPanel">
                    <div className="commandRow">
                        <PanelTitle
                            classes="listTitle link"
                            title={Translations.Documents + " - " + Translations.Favorites}
                            onClick={() => customHistory.push("/document")}
                        />
                        <div className="buttonContainer flexRight">
                            <div className="buttonSpacer"></div>
                        </div>
                    </div>
                    <div className="panelContent listContainer documentListContainer">
                        <div className="lineContainer mainLineContainer documentList">
                            {this.hasBeenInitialized && !props.state?.isLoading && documents.length < 1 &&
                                <FrontPageInfoMessage
                                    message={Translations.NoFavoritesToShow}
                                />
                            }
                            {documents.map((document) => (
                                <div className="blockContainer" key={document.id}>
                                    <div className="company">{document.name}</div>
                                    {document.items.map((item) => (
                                        <DocumentListBlock
                                            key={item.id}
                                            companyId={document.id}
                                            item={item}
                                            selected={false}
                                            favorite={false}
                                            first={false}
                                            isLastOpenedDocument={false}
                                            onClick={this.handleDocumentLineClick}
                                            onLongPress={null}
                                            onRefreshList={null}
                                            onRemoveFavorite={null}
                                        />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}